import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[zciKeyboardEventRegexValidate]',
})
export class KeyboardEventRegexValidateDirective {
    @Input('zciKeyboardEventRegexValidate') regex: RegExp;

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        if (this.regex) {
            if (!this.regex.test(event.key)) {
                event.preventDefault();
                return false;
            }
        }
        return true;
    }
}
